import React, { SyntheticEvent, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Typography, alpha } from '@mui/material';
import Tab from '@mui/material/Tab';
import { Home } from '@mui/icons-material';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';
import DevicesTab from './_components/DevicesTab';
import GroupsTab from './_components/GroupsTab';
import SchedulesTab from './_components/SchedulesTab';

const ACCENT = '#38bdf8';

const HomeAssistantPage = () => {
  const [value, setValue] = useState('1');

  const handleChange = (_event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <HeaderDashboard />
      <Box sx={{ px: { xs: 2, md: 4 }, pb: 4 }}>
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 5,
            p: { xs: 3, md: 4 },
            mb: 3,
            backgroundColor: alpha('#ffffff', 0.05),
            border: `1px solid ${alpha(ACCENT, 0.3)}`,
            color: '#fff',
            boxShadow: '0 20px 45px rgba(0,0,0,0.35)',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: `radial-gradient(circle at 0% 0%, ${alpha(ACCENT, 0.18)}, transparent 55%)`,
            }}
          />
          <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: alpha(ACCENT, 0.15),
                color: ACCENT,
                flexShrink: 0,
              }}
            >
              <Home sx={{ fontSize: 30 }} />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: { xs: 24, md: 30 } }}>
                Home Assistant
              </Typography>
              <Typography sx={{ opacity: 0.85, fontSize: 14 }}>
                Vincule dispositivos, agrupe e acione tudo direto do AlertAI.
              </Typography>
            </Box>
          </Box>
        </Box>

        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              mb: 3,
            }}
          >
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label="Dispositivos" value="1" />
              <Tab label="Grupos" value="2" />
              <Tab label="Agendamentos" value="3" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0 }}>
            <DevicesTab />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0 }}>
            <GroupsTab />
          </TabPanel>
          <TabPanel value="3" sx={{ p: 0 }}>
            <SchedulesTab />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

export default HomeAssistantPage;
